module.exports = __webpack_public_path__ + "media/src/images/bg/bg9-544b4f114c565fc192e3e0e3ce9544de.jpg";